module.exports = __webpack_public_path__ + "img/product_top.9bf0ff76.jpg";